
import { PURCHASING_API } from '../../../../common/constants/api';
import { leadsServiceApi } from '../../../../infra/purchasingApi.service';

/* export const getBikeDuplicates = (vrm = null, bike_id) => (
    api.send({
           api: 'db',
           model: 'Bike_lead',
           action: 'Read',
           options: {
               attributes: ['vrm'],
               include: {
                   model: 'Lead',
                   path: 'leads',
                   attributes: ['created_date', 'valuations.valuation', 'valuations.valuation_by'],
                   include: [
                       {
                           model: 'Lead_source',
                           path: 'ref_lead_source',
                           attributes: ['abbr']
                       },
                       {
                           model: 'Lead_status',
                           path: 'ref_lead_status',
                           attributes: ['name']
                       }
                   ]
               },
               where: {
                   vrm,
                   _id: {
                       $ne: bike_id
                   }
               }
           }
       })
       .then(response => response)
       .catch(error => error)
); */

export const getLeadsDuplicateByLeadId = async (leadId) => {
    const res = await leadsServiceApi({
        method: 'get',
        url: `${PURCHASING_API.LEADS_DUPLICATES}?leadId=${leadId}`,
    });

    if (res?.data) {
        return {
            result: true,
            options: res.data,
        };
    }
    return ({
        result: false,
        error: 'Something wrong with leadService',
    });
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_bike_duplicates_request.js